// removed by extract-text-webpack-plugin
module.exports = {"linkEpicAccountBox":"_3QEuqz_orpPuZJB26lMSmV","linkEpicAccountBoxInner":"_2RF1pBdQaLIvzze-HBx4_Y","formFields":"_3QPMzvbRHTq1-REQqru6Qn","emailField":"GU7rXAE0KrnWqupbCY056","buttonsGroup":"_2t1x-4U0PIbzAygNZQmu-L","footer":"_3TZu0LZyisdKFjm5v4PhLC","error":"_3MYztPYN_oL7idtEQESDuX","footerContainer":"_13du6DV4aY6MOQeSG7NCZ_","button":"YTDnvHLdqO5negwnp7VWN","row":"Bh_9VrqBv7tpOoNTf-V0U","login":"_12HNKj1XvgnrPA4zxQCpVd","loginError":"TFFy44w_w6lVybEvwMoOZ"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/LinkEpicAccountBox.scss
// module id = 1277
// module chunks = 0